import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BFormCheckbox } from "bootstrap-vue";
import { ref, watch } from "vue";
import FormGeneric from "@/components/Form/FormGeneric.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetPermissionsForm',
    props: {
        loading: { type: Boolean },
        simplePermissions: { type: Boolean },
        title: null,
        checked: { type: Boolean },
        formConfig: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faUsers);
        const selectedAdvancedForm = ref(false);
        const checkedInForm = ref(props.checked);
        async function change(value) {
            emit("change", value);
        }
        watch(props, () => {
            checkedInForm.value = props.checked;
        });
        return { __sfc: true, props, selectedAdvancedForm, checkedInForm, emit, change, faUsers, FontAwesomeIcon, BFormCheckbox, FormGeneric, LoadingSpan };
    }
});
